'use client'

import { useEffect } from 'react'
import { reportClientLog } from '@/lib/client-logger'

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    console.error(error)
    reportClientLog({
      source: 'react-error-boundary',
      message: error.message || 'Route render error',
      errorName: error.name,
      stack: error.stack,
      extra: error.digest ? { digest: error.digest } : undefined,
    })
  }, [error])

  return (
    <div className="flex-grow flex flex-col items-center justify-center p-8 font-mono text-center">
      <p className="text-xs uppercase tracking-widest opacity-50 mb-2">Fehler</p>
      <h2 className="text-xl font-bold uppercase mb-4">Diese Seite ist momentan nicht verfügbar</h2>
      <p className="text-sm opacity-70 mb-6 max-w-sm">
        Diese Seite konnte nicht geladen werden. Bitte versuche es gleich nochmal.
      </p>
      <button
        onClick={reset}
        className="border border-ink px-4 py-2 text-xs uppercase tracking-widest hover:bg-ink hover:text-paper transition-colors"
      >
        Erneut versuchen
      </button>
    </div>
  )
}
